/**
 * Everything the chat bot knows about Suraj. Edit this file to change what
 * the bot can answer — no other code needs to change for content updates.
 */

export const PROFILE = {
  name: "Suraj Verma",
  title: "Full Stack Developer",
  location: "Indore, Madhya Pradesh, India",
  email: "vermasuraj008@gmail.com",
  phone: "+91 8602036694",
  linkedin: "https://www.linkedin.com/in/surajverma008",
  github: "https://github.com/vermasuraj11011",
  resume: "https://drive.google.com/file/d/1PO2lIJ6dNLEWVRy8eC6TkQED11eFh5Sh/view?usp=sharing",
  spokenLanguages: "English, Hindi & Brij",
  hobbies: "Chess, Reading & Coding",
  // First software role (Zomentum) — used to compute years of experience.
  careerStart: new Date(2022, 0, 1),
};

// Add formal degree / school entries here (most recent first) and the
// education answer picks them up automatically, e.g.
// {name: "XYZ Institute of Technology", detail: "B.E. Mechanical Engineering", period: "2014 - 2018"},
export const EDUCATION = [
  {
    name: "Masai School",
    detail: "30-week full-time Full Stack Web Development program (Java, Spring Boot, DSA, System Design)",
    period: "Jul 2021 - Jan 2022",
  },
];

export const COMPANIES = [
  {
    id: "apple_maps",
    name: "Apple Maps",
    aliases: ["apple maps", "apple", "maps", "unify", "unify technologies", "unify tech"],
    period: "Sep 2024 - Present",
    role: "Software Developer",
    // The work is done directly with Apple; Unify is only the employer.
    employer: "Unify Technologies",
    summary:
      "Suraj works directly with Apple's teams on Apple Maps — building large-scale address automation and geospatial data processing that ingests raw location data from multiple vendors and turns it into high-quality map data. He's also building an agentic AI solution using LangChain.",
    stack: ["Scala", "Java", "Play Framework", "Spark", "Cassandra", "Python", "LangChain", "FastAPI", "Jenkins", "Airflow", "AWS EMR", "Splunk"],
    highlights: [
      "Built scalable Spark pipelines to ingest, validate, transform and enrich geospatial data from multiple vendors.",
      "Building an agentic AI solution using LangChain, with LLM-powered agents that automate multi-step workflows.",
      "Designed microservices that automate the address-processing workflow.",
      "Developed AI/ML models for intelligent address placement.",
      "Built Python dashboards for data quality and pipeline monitoring, plus FastAPI services.",
      "Collaborates with Apple's US & European engineering teams on global releases.",
    ],
  },
  {
    id: "rawcubes",
    name: "Rawcubes",
    aliases: ["rawcubes", "raw cubes", "rawcube"],
    period: "Sep 2023 - Aug 2024",
    role: "Software Developer (also Scrum Master)",
    summary:
      "Rawcubes builds scalable, self-service analytics solutions that help organisations break data silos and turn raw data into insights.",
    stack: ["Scala", "Java", "Spring Boot", "Cassandra", "MySQL", "Spark", "BigQuery"],
    highlights: [
      "Broke a monolithic application down into microservices.",
      "Upgraded Spring / Java versions and added Spring Security 6 for auth.",
      "Fixed Cassandra query performance issues.",
      "Built new Spark data-pipeline features to read/write from many sources.",
    ],
  },
  {
    id: "zomentum",
    name: "Zomentum",
    aliases: ["zomentum"],
    period: "Jan 2022 - Aug 2023",
    role: "Software Developer",
    summary:
      "Zomentum is an AI-enabled platform for quickly creating compelling sales proposals and winning more deals.",
    stack: ["Scala", "Play Framework", "AWS", "MongoDB", "DataDog", "GitLab"],
    highlights: [
      "Integrated Zoom, Microsoft Teams and Google Meet into the platform.",
      "Worked with AWS Lambda, SES, SQS, Parameter Store and S3.",
      "Resolved client DKIM, SPF and DMARC email issues.",
      "Built monitoring queries in DataDog to catch failures early.",
    ],
  },
  {
    id: "masai_school",
    name: "Masai School",
    aliases: ["masai", "masai school", "bootcamp"],
    period: "Jul 2021 - Jan 2022",
    role: "Student",
    summary:
      "An online coding bootcamp with a full-time 30-week full-stack course — where Suraj learned web development, coding ~12 hours a day.",
    stack: ["Java", "Spring Boot", "DSA", "MySQL", "Git", "Express", "JavaScript", "System Design"],
    highlights: [
      "Daily DSA and backend lectures with weekly DSA tests.",
      "Monthly team & solo projects, including Shine and EaseMyTrip clones.",
      "Designed systems like RedBus, WhatsApp and an LMS.",
      "Mentored juniors on their projects and assignments.",
    ],
  },
];

export const PROJECTS = [
  {
    id: "contact_manager",
    name: "Contact Manager App",
    aliases: ["contact manager", "contactmanager"],
    description: "A web application where users can manage their contacts, with payments via Razorpay and email via AWS.",
    stack: ["Java", "Spring Boot", "Spring Security", "MySQL", "Thymeleaf", "AWS", "Python"],
    github: "https://github.com/vermasuraj11011/ContactManager",
  },
  {
    id: "blogging_app",
    name: "Blogging Application",
    aliases: ["blogging app", "blogging application", "blog app", "blogging"],
    description: "A secure server-side app to create and browse blogs with category search, JWT authentication and Swagger docs.",
    stack: ["Java", "Spring Boot", "Spring Security", "MySQL"],
    github: "https://github.com/vermasuraj11011/bloging",
  },
  {
    id: "course_app",
    name: "Course Application",
    aliases: ["course app", "course application"],
    description: "A client-side app where admins manage courses and users can browse and subscribe to them.",
    stack: ["React", "HTML", "CSS", "JavaScript"],
    github: "https://github.com/vermasuraj11011/React_Basic",
  },
  {
    id: "shine_clone",
    name: "Shine.com Clone",
    aliases: ["shine", "shine clone", "shine com"],
    description: "A job portal clone with job search and basic user authentication.",
    stack: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/vermasuraj11011/Shine-Clone",
    live: "https://shine-clone.netlify.app/",
  },
  {
    id: "medikal",
    name: "Medikal",
    aliases: ["medikal", "medical app", "epharmacy", "pharmacy"],
    description: "An online pharmacy to search medicines and get them delivered, with OTP verification and parcel tracking.",
    stack: ["HTML", "CSS", "JavaScript", "Spring Boot", "MySQL"],
    github: "https://github.com/rahul428428/ePharmacy-Clone",
    live: "https://medikal.netlify.app/",
  },
  {
    id: "easemytrip_clone",
    name: "EaseMyTrip Clone",
    aliases: ["easemytrip", "ease my trip", "easemytrip clone"],
    description: "A trip-booking platform clone with flight booking built on self-made APIs.",
    stack: ["HTML", "CSS", "JavaScript", "Express", "MongoDB"],
    github: "https://github.com/vermasuraj11011/EaseMyTrip-clone",
    live: "https://easemytrip.netlify.app/",
  },
];

export const SKILL_GROUPS = [
  ["Languages", ["Scala", "Java", "Python", "JavaScript"]],
  ["Backend", ["Spring Boot", "Play Framework", "Express", "Flask", "FastAPI"]],
  ["Frontend", ["React", "HTML", "CSS", "Thymeleaf"]],
  ["Databases", ["MySQL", "Cassandra", "MongoDB", "BigQuery"]],
  ["Big Data", ["Spark", "Kafka", "Hadoop", "Hive", "Airflow"]],
  ["Cloud", ["AWS", "GCP", "Azure"]],
  ["DevOps", ["Docker", "Jenkins", "Git", "Bitbucket", "GitLab"]],
  ["AI / ML", ["LangChain", "Langfuse", "TensorFlow"]],
];

// Canonical skill name -> extra ways people may write it. Every name used in
// SKILL_GROUPS / COMPANIES / PROJECTS stacks should appear here.
export const SKILL_ALIASES = {
  Scala: ["scala"],
  Java: ["java"],
  Python: ["python"],
  JavaScript: ["javascript", "js"],
  "Spring Boot": ["spring", "spring boot", "springboot"],
  "Spring Security": ["spring security"],
  "Play Framework": ["play framework", "play"],
  Express: ["express", "expressjs", "express js"],
  Flask: ["flask"],
  FastAPI: ["fastapi", "fast api"],
  React: ["react", "reactjs", "react js"],
  HTML: ["html"],
  CSS: ["css"],
  Thymeleaf: ["thymeleaf"],
  MySQL: ["mysql", "sql"],
  Cassandra: ["cassandra"],
  MongoDB: ["mongodb", "mongo"],
  BigQuery: ["bigquery", "big query", "google bq", "bq"],
  Spark: ["spark", "pyspark", "apache spark"],
  Kafka: ["kafka"],
  Hadoop: ["hadoop"],
  Hive: ["hive"],
  Airflow: ["airflow", "apache airflow"],
  AWS: ["aws", "amazon web services", "lambda", "sqs", "ses", "s3"],
  "AWS EMR": ["emr", "aws emr"],
  GCP: ["gcp", "google cloud"],
  Azure: ["azure"],
  Docker: ["docker"],
  Jenkins: ["jenkins"],
  Git: ["git"],
  Bitbucket: ["bitbucket"],
  GitLab: ["gitlab", "git lab"],
  Splunk: ["splunk"],
  DataDog: ["datadog", "data dog"],
  LangChain: ["langchain", "lang chain"],
  Langfuse: ["langfuse"],
  TensorFlow: ["tensorflow", "tensor flow"],
  DSA: ["dsa", "data structure", "data structures", "algorithms"],
  "System Design": ["system design"],
};

export const DEFAULT_SUGGESTIONS = [
  "Who is Suraj?",
  "Where does he work now?",
  "What are his skills?",
  "Tell me about his education",
];
